import React, {  useState } from "react";
import Form from 'react-bootstrap/Form';
import Async from 'react-select/async';
import Creatable from 'react-select/creatable';
import "./FormikInput.css";
/**
 * 
 * @param {{formik: JSON, fieldName: string, placeholder: string, jsonField: {
 *          id: string, type: string, required: boolean, placeholder: string},
 *          className: string, loadAsyncOptions: function, lang: json}} props 
 * @returns 
 */
export default function FormikInput(props) {
  const [loading, setLoading] = useState(false);

  /**
   * Creates the label string by concatena the fieldName with '*' in case the field
   * is required.
   * @returns String label.
   */
  const handleLabel = () => {
    let label = "";
    label = `${props.fieldName}${props.jsonField.required ? "(*)" : ""}`;
    return label;
  }

  /**
 * Handles props.jsonField.type in case it's checkbox or text field.
 * @returns React component
 */
  const handleCheckbox = () => {
    if (props.jsonField.type === "checkbox") {
      return (
        <Form.Check
          label={handleLabel()}
          key={props.jsonField.id + "2"}
          id={props.jsonField.id}
          name={props.jsonField.id}
          type={props.jsonField.type}
          checked={props.formik.values[props.jsonField.id]}
          onChange={props.formik.handleChange}
          onBlur={props.formik.handleBlur}
          className={props.className ? props.className : ""}
          isInvalid={props.formik.touched[props.jsonField.id] && !!props.formik.errors[props.jsonField.id]}
        />
      )
    }

    return (
      <>
        <Form.Label key={props.jsonField.id + "1"}>
          {handleLabel()}
        </Form.Label>

        <Form.Control
          key={props.jsonField.id + "2"}
          id={props.jsonField.id}
          name={props.jsonField.id}
          type={props.jsonField.type}
          value={props.formik.values[props.jsonField.id]}
          autoComplete="off"
          placeholder={props.jsonField.placeholder ? props.jsonField.placeholder : ""}
          onChange={props.formik.handleChange}
          onBlur={props.formik.handleBlur}
          className={props.className ? props.className : ""}
          isInvalid={props.formik.touched[props.jsonField.id] && !!props.formik.errors[props.jsonField.id]}
        />
      </>
    )
  }

  /**
   * Establish standard way to handle events fired off in select functionality.
   * @param {} _ 
   * @param {JSON} type 
   */
  const handleChangeInSelect = (_, type) => {
    if (type.action === "remove-value" || type.action === "pop-value") {
      props.formik.setFieldValue(props.jsonField.id,
        props.formik.values[props.jsonField.id].filter((v) => {
          return v !== type.removedValue;
        }))
    } else if (type.action === "clear") {
      props.formik.setFieldValue(props.jsonField.id, []);
    } else if (type.action === "select-option") {
      props.formik.setFieldValue(props.jsonField.id, [...props.formik.values[props.jsonField.id], type.option]);
    }
  }

  /**
   * Creates the corresponding field to props.jsonField.type.
   * @returns React component
   */
  const createField = () => {
    const invalidField = props.formik.touched[props.jsonField.id] && !!props.formik.errors[props.jsonField.id];
    // For keywords, could be interesting to create things on the fly.
    if (props.jsonField.type === "select-look") {
      return (
        <>
          <Form.Label key={props.jsonField.id + "1"}>
            {handleLabel()}
          </Form.Label>

          <Async loadOptions={(text) => { return props.loadAsyncOptions(text, setLoading, props.jsonField.id, props.lang) }}
            placeholder={props.jsonField.placeholder}
            className={invalidField ? "formik-input-field-error" : ""} styles={{ control: (provided, state) => ({ ...provided, "borderColor": state.isFocused ? "hsl(0, 0%, 80%)" : invalidField ? "#dc3545" : "hsl(0, 0%, 80%)" }) }}
            onBlur={props.formik.handleBlur}
            onChange={handleChangeInSelect}
            value={props.formik.values[props.jsonField.id]}
            isLoading={loading}
            isMulti
            inputId={props.jsonField.id}
          />

          {invalidField ? <div className="formik-input-text-error">
            {props.formik.errors[props.jsonField.id]}
          </div> : null}
        </>
      )
    }

    if (props.jsonField.type === "select-create") {
      return (
        <>
          <Form.Label key={props.jsonField.id + "1"}>
            {handleLabel()}
          </Form.Label>

          <Creatable isMulti
            placeholder={props.jsonField.placeholder}
            onBlur={props.formik.handleBlur}
            className={invalidField ? "formik-input-field-error" : ""} styles={{ control: (provided, state) => ({ ...provided, "borderColor": state.isFocused ? "hsl(0, 0%, 80%)" : invalidField ? "#dc3545" : "hsl(0, 0%, 80%)" }) }}
            onCreateOption={(e) => { props.formik.setFieldValue(props.jsonField.id, [...props.formik.values[props.jsonField.id], { value: e, label: e }]) }}
            value={props.formik.values[props.jsonField.id]}
            onChange={handleChangeInSelect}
            inputId={props.jsonField.id}
          />
        </>
      )
    }

    return (
      <>
        {handleCheckbox()}

        <Form.Control.Feedback type="invalid" key={props.jsonField.id + "3"}>
          {props.formik.errors[props.jsonField.id]}
        </Form.Control.Feedback>
      </>
    )
  }

  return (
    <Form.Group key={props.jsonField.id}>
      {createField()}
    </Form.Group>
  );
};
